"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiLogoEmbeddedOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_svg_utils_1 = require("@desygner/ui-common-svg-utils");
const components_1 = require("../../components");
const useSubmitHandler_1 = require("../../hooks/useSubmitHandler");
const AiLogoOverview_style_1 = require("./AiLogoOverview.style");
const AiLogoStyles_1 = require("./AiLogoStyles");
const AiLogoStyles_style_1 = require("./AiLogoStyles.style");
function AiLogoEmbeddedOverview({ colorSelectOptions, crop, imageStyles, industryNames, insertNewAsset, labels, loadingVideo, objectFit, onPromptSubmit, outputFormat, logoInformation, onStatusChange, onCancelFlow, allowRegenerate, onFlowInformationChange, previewUrl, }) {
    const [view, setView] = (0, react_1.useState)('edit');
    const [selectedStyle, setSelectedStyle] = (0, react_1.useState)(imageStyles[0].value);
    const [stylesOpened, setStylesOpened] = (0, react_1.useState)(false);
    const [formValues, setFormValues] = (0, react_1.useState)({
        companyName: '',
        includeCompanyName: true,
        industryName: '',
        logoColor: 'transparent',
    });
    const [industryOptions, setIndustryOptions] = (0, react_1.useState)(industryNames);
    const { onCancel: onCancelSubmit, onClear, onSubmit, prompt, result, setPrompt, status, textAreaRef, } = (0, useSubmitHandler_1.useSubmitHandler)(onPromptSubmit, onStatusChange);
    const handleIndustryChange = (0, react_1.useCallback)((industryName) => {
        setIndustryOptions(() => {
            return industryNames.map((industry) => {
                return Object.assign(Object.assign({}, industry), { isSelected: industry.value.toLowerCase() === industryName.toLowerCase() });
            });
        });
    }, [industryNames]);
    (0, react_1.useEffect)(() => {
        if (!logoInformation)
            return;
        const style = logoInformation.style || imageStyles[0].value;
        const companyName = logoInformation.company || '';
        const includeCompanyName = logoInformation.includeCompanyName || true;
        const industryName = logoInformation.industry || '';
        const logoColor = logoInformation.color || 'transparent';
        setPrompt(logoInformation.prompt);
        handleIndustryChange(industryName);
        setSelectedStyle(style);
        setFormValues({
            companyName,
            includeCompanyName,
            industryName,
            logoColor,
        });
    }, [handleIndustryChange, setPrompt, onSubmit, logoInformation, imageStyles]);
    (0, react_1.useEffect)(function autoSubmit() {
        if (!logoInformation)
            return;
        const style = logoInformation.style || imageStyles[0].value;
        const companyName = logoInformation.company || '';
        const includeCompanyName = logoInformation.includeCompanyName || true;
        const industryName = logoInformation.industry || '';
        const logoColor = logoInformation.color || 'transparent';
        (logoInformation === null || logoInformation === void 0 ? void 0 : logoInformation.submit) &&
            onSubmit(logoInformation.prompt, {
                logoStyle: style,
                company: companyName,
                includeCompanyName,
                industryName,
                logoColor,
            });
    }, []);
    (0, react_1.useEffect)(() => {
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(status, result || '');
        setView(status === 'success' || status === 'error' ? 'preview' : 'edit');
    }, [status, result]);
    (0, react_1.useEffect)(() => {
        !allowRegenerate && !result && !previewUrl && (onCancelFlow === null || onCancelFlow === void 0 ? void 0 : onCancelFlow());
        (previewUrl || result) && setView('preview');
    }, [allowRegenerate, result, previewUrl]);
    const imagePreview = outputFormat === 'base64' ? `data:image/png;base64, ${result}` : result;
    const logoData = {
        company: formValues.companyName,
        includeCompanyName: formValues.includeCompanyName,
        industryName: formValues.industryName,
        logoColor: formValues.logoColor,
        logoStyle: selectedStyle,
    };
    const onCancel = (0, react_1.useCallback)(() => {
        if (result) {
            setView('preview');
        }
        else if (status === 'idle' && onCancelFlow) {
            onCancelFlow();
        }
        else {
            onCancelSubmit();
        }
    }, [result, onCancelFlow, onCancelSubmit, status]);
    const handleFormChange = (0, react_1.useCallback)((data) => {
        setFormValues(data);
        const aiLogoData = {
            flowType: 'logo',
            prompt: prompt || '',
            company: data.companyName,
            includeCompanyName: data.includeCompanyName,
            industry: data.industryName,
            color: data.logoColor,
            style: selectedStyle,
            submit: false,
        };
        onFlowInformationChange === null || onFlowInformationChange === void 0 ? void 0 : onFlowInformationChange(aiLogoData);
    }, [onFlowInformationChange, selectedStyle, prompt]);
    const handlePromptChange = (0, react_1.useCallback)((prompt) => {
        setPrompt(prompt);
        const aiLogoData = {
            flowType: 'logo',
            prompt,
            company: formValues.companyName,
            includeCompanyName: formValues.includeCompanyName,
            industry: formValues.industryName,
            color: formValues.logoColor,
            style: selectedStyle,
            submit: false,
        };
        onFlowInformationChange && onFlowInformationChange(aiLogoData);
    }, [formValues, onFlowInformationChange, selectedStyle, setPrompt]);
    const handleStyleChange = (0, react_1.useCallback)((style) => {
        setSelectedStyle(style);
        const aiLogoData = {
            flowType: 'logo',
            prompt: prompt || '',
            company: formValues.companyName,
            includeCompanyName: formValues.includeCompanyName,
            industry: formValues.industryName,
            color: formValues.logoColor,
            style,
            submit: false,
        };
        onFlowInformationChange && onFlowInformationChange(aiLogoData);
    }, [formValues, onFlowInformationChange, prompt]);
    const isPreviewMode = (0, react_1.useMemo)(() => previewUrl && !result, [previewUrl, result]);
    return ((0, jsx_runtime_1.jsxs)(AiLogoOverview_style_1.StyledEmbeddedContainer, { children: [(0, jsx_runtime_1.jsxs)(AiLogoOverview_style_1.StyledWrapper, { isEmbedded: true, children: [result && view === 'preview' && status !== 'loading' && ((0, jsx_runtime_1.jsx)(components_1.AppPreview, { isEmbedded: true, labels: labels, onClick: () => insertNewAsset(result, { ratio: 1 }), result: previewUrl || result, status: status, title: status === 'error' ? result : prompt || '', type: status === 'success' ? 'image' : 'text', onChangeView: () => setView('edit'), allowRegenerate: allowRegenerate, children: status === 'success' && imagePreview && ((0, jsx_runtime_1.jsx)(components_1.AppImagePreview, { onClick: () => insertNewAsset(result, { ratio: 1 }), children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Image, { source: (0, ui_common_svg_utils_1.getCORSSecureUrl)(imagePreview), rounded: true }) })) })), isPreviewMode &&
                        previewUrl &&
                        view === 'preview' &&
                        status !== 'loading' && ((0, jsx_runtime_1.jsx)(components_1.AppPreview, { isEmbedded: true, labels: labels, onClick: () => insertNewAsset(previewUrl, { ratio: 1 }), result: previewUrl, status: status, title: prompt || '', type: 'image', onChangeView: () => setView('edit'), allowRegenerate: false, children: (0, jsx_runtime_1.jsx)(components_1.AppImagePreview, { onClick: () => insertNewAsset(previewUrl, { ratio: 1 }), children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Image, { source: (0, ui_common_svg_utils_1.getCORSSecureUrl)(previewUrl), rounded: true }) }) })), (0, jsx_runtime_1.jsx)(components_1.AppContent, { isEmbedded: true, crop: crop, isLoading: status === 'loading', loadingVideo: loadingVideo, loadingMessage: labels.loadingMessage, objectFit: objectFit, children: view === 'edit' && ((0, jsx_runtime_1.jsx)(components_1.AppForm, { inputRef: textAreaRef, labels: labels, result: result !== null && result !== void 0 ? result : undefined, showSubtitle: ['idle', 'error'].includes(status), status: status, prompt: prompt || '', onPromptChange: handlePromptChange, onPromptSubmit: (prompt) => onSubmit(prompt, logoData), children: status !== 'loading' && ((0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyledChildrenContainer, { children: [(0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyledInputWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'BodyHeavy', children: labels.colorName }), (0, jsx_runtime_1.jsx)(ui_common_components_1.ColorSelect, { limit: 8, options: colorSelectOptions, defaultValue: formValues.logoColor, customColorLabel: labels.chooseCustomColor, transparentLabel: labels.colorNone, onChange: (color) => handleFormChange(Object.assign(Object.assign({}, formValues), { logoColor: color })) })] }), (0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyledInputWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'BodyHeavy', children: labels.industryName }), (0, jsx_runtime_1.jsx)(AiLogoStyles_style_1.StyledInputCompanyWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Select, { options: industryOptions, onChange: (value) => {
                                                        handleIndustryChange(value);
                                                        handleFormChange(Object.assign(Object.assign({}, formValues), { industryName: value }));
                                                    } }) })] }), (0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyledInputWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'BodyHeavy', children: labels.companyName }), (0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyledInputCompanyWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: "company-name", name: "ai-prompt", placeholder: labels.companyNamePlaceholder, onChange: (value) => handleFormChange(Object.assign(Object.assign({}, formValues), { companyName: value })), value: formValues.companyName }), (0, jsx_runtime_1.jsx)(AiLogoStyles_style_1.StyledSwitchWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Switch, { checked: true, onChange: (value) => handleFormChange(Object.assign(Object.assign({}, formValues), { includeCompanyName: value })) }) })] })] })] })) })) }), view === 'edit' && status !== 'loading' && ((0, jsx_runtime_1.jsx)(AiLogoStyles_1.AiLogoStyles, { labelSeeMore: labels.seeMore, maxStyles: ['success', 'error'].includes(status) ? 3 : 6, onStyleChange: handleStyleChange, selectedStyle: selectedStyle, setStylesOpened: setStylesOpened, styles: imageStyles, stylesOpened: stylesOpened, title: labels.chooseStyle }))] }), status === 'loading' ||
                isPreviewMode ||
                (!allowRegenerate && status !== 'idle') || ((0, jsx_runtime_1.jsx)(components_1.AppFooter, { isEmbedded: true, children: (0, jsx_runtime_1.jsx)(components_1.AppButtons, { view: view, isEmbedded: true, labels: labels, onCancel: onCancel, onClear: onClear, onSubmit: (prompt) => onSubmit(prompt, logoData), prompt: prompt, status: status }) }))] }));
}
exports.AiLogoEmbeddedOverview = AiLogoEmbeddedOverview;
//# sourceMappingURL=AiLogoEmbeddedOverview.js.map